import { Link } from 'react-router-dom';
import { Button } from '@dopomogai/ui';

import {
  WEBSITE_V2_PRIMARY_CTA,
  websiteV2HeaderLinks,
} from '../content';

type Props = {
  primaryHref?: string;
  primaryLabel?: string;
};

export function WedgeHeader({
  primaryHref = '/ai-revenue-audit',
  primaryLabel = WEBSITE_V2_PRIMARY_CTA,
}: Props) {
  return (
    <header className="sticky top-0 z-40 border-b border-slate-200/80 bg-[#fffdf8]/95 backdrop-blur">
      <div className="mx-auto flex max-w-6xl items-center justify-between gap-4 px-4 py-3 md:px-8">
        <Link to="/" className="text-sm font-black uppercase tracking-[0.24em] text-slate-900">
          Dopomogai
        </Link>
        <nav className="hidden items-center gap-6 md:flex">
          {websiteV2HeaderLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="text-sm font-bold text-slate-600 transition-colors hover:text-slate-950"
            >
              {link.label}
            </a>
          ))}
        </nav>
        <Button
          size="sm"
          text={primaryLabel}
          onClick={() => window.location.assign(primaryHref)}
          className="hidden md:inline-flex"
        />
      </div>
    </header>
  );
}

export default WedgeHeader;
